import { Typography } from '@material-ui/core'
import { styled, withStyles } from '@material-ui/core/styles'

import GetStartedWithBox from 'artkive/components/sections/GetStartedWithBox/GetStartedWithBox'
import theme from 'artkive/utils/theme'

import { gutters } from './Keepsakes.style'

export const GetStarted = withStyles((muiTheme) => {
  const { breakpoints, spacing } = muiTheme

  return {
    mainWrapper: {
      [breakpoints.up('md')]: {
        height: 750,
        alignItems: 'flex-start',
      },
    },
    description: {
      [breakpoints.up('md')]: {
        justifyContent: 'flex-start',
        padding: '48px 20px 0 100px',
      },
    },
    subtitle: {
      [breakpoints.down('xs')]: {
        maxWidth: 362,
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    },
    bullets: {
      [breakpoints.up('md')]: {
        maxWidth: 420,
      },
    },
    cta: {
      [breakpoints.down('sm')]: {
        marginTop: spacing(3),
      },
    },
    footerNotice: {
      [breakpoints.up('md')]: {
        marginTop: 44,
        maxWidth: 295,
      },
    },
    noticeWrapper: {
      padding: '40px 0',
      textAlign: 'left',
      borderTop: `1px solid ${theme.colors.sky[400]}`,
      borderBottom: `1px solid ${theme.colors.sky[400]}`,
      [breakpoints.down('sm')]: {
        padding: '40px 16px',
      },
    },
    noticeContainer: gutters(muiTheme),
  }
})(GetStartedWithBox)

export const NoticeTitle = styled(Typography)(({ theme: { breakpoints } }) => ({
  color: theme.colors.primary.dark,
  fontWeight: 700,
  [breakpoints.up('md')]: {
    textAlign: 'center',
  },
}))
